(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guide-hub"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var topChromeSelectors = [
      'header',
      '.announcement-bar',
      '.announcement-bar-section',
      '#shopify-section-new-header',
      '#shopify-section-announcement-bar',
      '.section-announcement-bar'
    ];

    function getTopChromeOffset() {
      var offset = 24;
      var seen = [];
      var nodes = document.querySelectorAll(topChromeSelectors.join(','));

      nodes.forEach(function(node) {
        if (seen.indexOf(node) !== -1) return;
        seen.push(node);

        var rect = node.getBoundingClientRect();
        var style = window.getComputedStyle(node);
        var isFixedTop = style.position === 'fixed' || style.position === 'sticky';
        var isVisibleTopChrome = rect.width > window.innerWidth * 0.5 && rect.height > 0 && rect.bottom > 0 && rect.top <= 4;

        if (isFixedTop && isVisibleTopChrome) {
          offset = Math.max(offset, Math.round(rect.bottom) + 24);
        }
      });

      return offset;
    }

    function updateGuideHubAnchorOffsets() {
      var offset = getTopChromeOffset();
      document.querySelectorAll('.sgh').forEach(function(section) {
        section.style.setProperty('--sgh-anchor-offset', offset + 'px');
      });

      return offset;
    }

    function scrollToGuideHubTarget(target) {
      var offset = updateGuideHubAnchorOffsets();
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: targetTop,
        behavior: 'auto'
      });
    }

    function initGuideHubAnchors() {
      document.querySelectorAll('.sgh__body h2, .sgh__body h3').forEach(function(heading) {
        if (heading.id || !heading.textContent) return;
        var slug = heading.textContent.toLowerCase()
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        if (!slug) return;
        var uniqueSlug = slug;
        var index = 2;
        while (document.getElementById(uniqueSlug)) {
          uniqueSlug = slug + '-' + index;
          index += 1;
        }
        heading.id = uniqueSlug;
      });

      updateGuideHubAnchorOffsets();

      document.querySelectorAll('.sgh__jump a[href^="#"]').forEach(function(link) {
        link.addEventListener('click', function(event) {
          var anchor = link.getAttribute('href').slice(1);
          var target = document.getElementById(anchor);
          if (!target) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          scrollToGuideHubTarget(target);

          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#' + anchor);
          } else {
            window.location.hash = anchor;
          }
        }, true);
      });

      if (window.location.hash) {
        window.setTimeout(function() {
          var target = document.getElementById(window.location.hash.slice(1));
          if (target) scrollToGuideHubTarget(target);
        }, 0);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGuideHubAnchors);
    } else {
      initGuideHubAnchors();
    }

    window.addEventListener('resize', updateGuideHubAnchorOffsets);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-guide-2026"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-hg26-chat]');
    if (!trigger) return;
    const bubble = document.querySelector('#stackhouse-chat-root .sh-bubble');
    const loader = document.getElementById('stackhouse-chat-loader');
    if (bubble) bubble.click();
    else if (loader) loader.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-sample-request-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var attributionKeys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "gclid",
      "fbclid"
    ];

    function checkoutRequestId() {
      var parameters = new URLSearchParams(window.location.search);
      if (parameters.get("sample_checkout") !== "1") return "";

      var requestId = (parameters.get("sample_request_id") || "").trim();
      return /^\d{10,30}$/.test(requestId) ? requestId : "";
    }

    function cartRoute(path) {
      var root =
        window.Shopify &&
        window.Shopify.routes &&
        typeof window.Shopify.routes.root === "string"
          ? window.Shopify.routes.root
          : "/";
      return root + path;
    }

    async function cartRequest(path, options) {
      var response = await fetch(cartRoute(path), options || {});
      var result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message || "Cart request failed");
      }
      return result;
    }

    function itemProperty(item, key) {
      var properties = (item && item.properties) || {};
      return properties[key] == null ? "" : String(properties[key]);
    }

    function hasSampleRequest(cart, variantId, requestId) {
      return (cart.items || []).some(function (item) {
        return (
          String(item.variant_id) === variantId &&
          itemProperty(item, "_sample_request_id") === requestId &&
          itemProperty(item, "_shipping_bucket") === "sample_set"
        );
      });
    }

    function showCheckoutError(root, message) {
      var statusMessage = root.querySelector("[data-sample-checkout-message]");
      var returnLink = root.querySelector("[data-sample-checkout-return]");
      var spinner = root.querySelector(".sample-request__spinner");

      if (spinner) spinner.hidden = true;
      if (statusMessage) statusMessage.textContent = message;
      if (returnLink) {
        var returnUrl = new URL("/pages/free-media-sample-set", window.location.origin);
        var previewThemeId = new URLSearchParams(window.location.search).get("preview_theme_id");
        if (previewThemeId) returnUrl.searchParams.set("preview_theme_id", previewThemeId);
        returnLink.href = returnUrl.toString();
        returnLink.hidden = false;
      }
    }

    async function addSampleToCurrentCart(root, requestId) {
      var status = root.querySelector("[data-sample-checkout-status]");
      var variantId = root.getAttribute("data-sample-variant-id");

      root.classList.add("is-checkout-bridge");
      if (status) status.hidden = false;

      if (!/^\d+$/.test(variantId || "")) {
        showCheckoutError(root, "Shopify checkout is not configured yet. Please return to the sample request.");
        return;
      }

      try {
        var cart = await cartRequest("cart.js");
        if (!hasSampleRequest(cart, variantId, requestId)) {
          await cartRequest("cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                  properties: {
                    _sample_request_id: requestId,
                    _shipping_bucket: "sample_set"
                  }
                }
              ]
            })
          });
        }

        await cartRequest("cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              sample_request_id: requestId,
              sample_source: "jotform"
            }
          })
        });

        cart = await cartRequest("cart.js");
        var requestIsOnCart =
          cart.attributes &&
          String(cart.attributes.sample_request_id || "") === requestId;

        if (!hasSampleRequest(cart, variantId, requestId) || !requestIsOnCart) {
          throw new Error("Sample request could not be verified in the cart");
        }

        window.top.location.replace(cartRoute("checkout"));
      } catch (error) {
        showCheckoutError(root, "We could not open Shopify checkout. Please return to the sample request and try again.");
      }
    }

    function storedTouch() {
      try {
        return JSON.parse(window.localStorage.getItem("stackhouse_utm") || "{}");
      } catch (error) {
        return {};
      }
    }

    function referringDomain() {
      if (!document.referrer) return "";
      try {
        return new URL(document.referrer).hostname;
      } catch (error) {
        return "";
      }
    }

    function attributionForRequest() {
      var current = new URLSearchParams(window.location.search);
      var currentTouch = {};
      var hasCurrentTouch = false;

      attributionKeys.forEach(function (key) {
        var value = current.get(key);
        if (value) {
          currentTouch[key] = value;
          hasCurrentTouch = true;
        }
      });

      var attribution = {};
      var method = "none";

      if (hasCurrentTouch) {
        attribution = currentTouch;
        method = "current_url";
      } else {
        var stored = storedTouch();
        attributionKeys.forEach(function (key) {
          if (stored[key]) attribution[key] = stored[key];
        });
        if (Object.keys(attribution).length > 0) method = "stored_site_touch";
      }

      attribution.landing_page_path = window.location.pathname;
      attribution.referrer_domain = referringDomain();
      attribution.attribution_capture_method = method;
      return attribution;
    }

    function initializeForm(root) {
      var requestId = checkoutRequestId();
      if (new URLSearchParams(window.location.search).get("sample_checkout") === "1") {
        if (requestId) {
          addSampleToCurrentCart(root, requestId);
        } else {
          root.classList.add("is-checkout-bridge");
          var status = root.querySelector("[data-sample-checkout-status]");
          if (status) status.hidden = false;
          showCheckoutError(root, "This checkout link is incomplete. Please return to the sample request.");
        }
        return;
      }

      var frame = root.querySelector("[data-sample-request-frame]");
      var formId = root.getAttribute("data-form-id");
      if (!frame || !formId) return;

      var formUrl = new URL("https://form.jotform.com/" + formId);
      var attribution = attributionForRequest();
      Object.keys(attribution).forEach(function (key) {
        if (
          attribution.attribution_capture_method === "current_url" &&
          attributionKeys.indexOf(key) !== -1
        ) {
          return;
        }
        if (attribution[key]) formUrl.searchParams.set(key, attribution[key]);
      });
      frame.src = formUrl.toString();

      var attachHandler = function () {
        if (typeof window.jotformEmbedHandler === "function") {
          window.jotformEmbedHandler("#" + frame.id, "https://form.jotform.com/");
        }
      };

      if (typeof window.jotformEmbedHandler === "function") {
        attachHandler();
      } else {
        var embedScript = document.getElementById("jotform-embed-handler");
        if (embedScript) {
          embedScript.addEventListener("load", attachHandler, { once: true });
        } else {
          embedScript = document.createElement("script");
          embedScript.id = "jotform-embed-handler";
          embedScript.src = "https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js";
          embedScript.async = true;
          embedScript.addEventListener("load", attachHandler, { once: true });
          document.head.appendChild(embedScript);
        }
      }

      var startButton = root.querySelector("[data-sample-request-start]");
      if (startButton) {
        startButton.addEventListener("click", function (event) {
          var target = document.getElementById("sample-request-form");
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "start"
          });
        });
      }
    }

    document.querySelectorAll("[data-sample-request]").forEach(initializeForm);
  })();

  } catch(e) { console.error(e); }
})();
})();
